import {jwtDecrypt} from "/src/shared/helper";
import {Plugins} from "@capacitor/core";
import axios from "axios";
import jwtInterceptor from "@/shared/jwtInterceptor";

const {Storage} = Plugins;

const state = () => ({
  authData: {
    token: "",
    refreshToken: "",
    tokenExp: "",
    userId: "",
    userName: "",
  },
  loginStatus: 'success',
  user:null
});

const mutations = {
  removeAuthToken(state)
  {
    state.authData =  {
      token: "",
      refreshToken: "",
      tokenExp: "",
      userId: "",
      userName: "",
    }
  },
  saveAuthToken(state, payload)
  {
    const jwtDecodeUserInfo = jwtDecrypt(payload.access_token);
    state.authData = {
      token: payload.access_token,
      refreshToken: payload.refresh_token,
      userId: jwtDecodeUserInfo.uid,
    };
  },
  saveLoginStatus(state, status)
  {
    state.loginStatus = status;
  },
  saveUserInfo(state, userInfo)
  {
    state.user = userInfo;
  }
};

const actions = {
  async getCurrentUserInfo({commit,state})
  {
    if (state.user)
      return state.user;
    const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;
    const info = await jwtInterceptor.get(apiUrl+'user/getFullInfo');
    if (info && info.data && info.data.user)
    {
      commit('saveUserInfo',info.data.user);
    }
  },
  async loadStorageTokens({commit})
  {
    const access_token = await Storage.get({key: "access_token"});
    const refresh_token = await Storage.get({key: "refresh_token"});
    if (access_token && refresh_token && access_token.value && refresh_token.value)
    {
      const tokenData = {
        access_token: access_token.value,
        refresh_token: refresh_token.value
      };
      commit("saveAuthToken", tokenData);
    }
  },
  async loginUser({commit}, payload)
  {
    const url = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + 'user/login';
    const response = await axios.post(url, payload,{
      headers:{
        'Access-Control-Allow-Origin':'*'
      }
    });
    console.log(response)
    if (response.status === 200 && response.data && response.data.ok)
    {
      await Storage.set({
        key: "access_token",
        value: response.data.token.token,
      });
      await Storage.set({
        key: "refresh_token",
        value: response.data.token.refreshToken,
      });

      const authResultData = {
        access_token: response.data.token.token,
        refresh_token: response.data.token.refreshToken
      }
      commit("saveAuthToken", authResultData);
      commit("saveLoginStatus", "success");
      console.log('success login')
      return authResultData;
    }
    else
    {
      commit("saveLoginStatus", "failed");
      return response.data;
    }
  },
  async logoutUser({commit})
  {
    Storage.remove({key:'access_token'})
    Storage.remove({key:'refresh_token'})
    commit("removeAuthToken");
    commit('saveUserInfo',null)
  }
};

const getters = {
  getLoginStatus(state)
  {
    return state.loginStatus;
  },
  getUserInfo(state)
  {
    return state.user;
  },
  getAuthData(state)
  {
    return state.authData;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};